'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



// WEBPACK FOOTER //
// ./src/frontend-lib/node_modules/axios/lib/cancel/isCancel.js